import styled, { css } from 'styled-components';
import { ResidenceCardStyled } from '../components/Cards/ResidencesCard/styled';
import { ItemCardStyled } from '../components/ui/ItemCard/styled';
import { Breakpoints } from './constants';

export const CardGridStyled = styled.div<{
  $isEmptyView?: boolean;
  component?: string;
}>`
  padding: 0 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px 11px;

  ${ResidenceCardStyled}, ${ItemCardStyled}, ${({ component }) =>
    component ?? ''} {
    max-width: 100%;
    margin-left: 0;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px 17px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
  }

  @media screen and (min-width: 1439px) {
    gap: 20px 30px;
  }

  ${({ $isEmptyView }) =>
    $isEmptyView &&
    css`
      display: block;
    `}
`;
